module.exports = __webpack_public_path__ + "img/persona-en.0a80494d.png";